/* eslint-disable */
import {
    queryQuestionList,
    queryQuesCreators,
    questionStatusUpdate,
    getTreesData,
    transferQuesClass,
    updateQuestionTrees,
    deleteQuestionTrees,
    addQuestionTrees,
    moveQuestionTrees,
    setFirstQuestion,
    setRevealQuestion,
    queryExtQuestionTotal,
    queryAnswersTotal
} from "@/views/zhiji/js/services/service.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import { isArray } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default module = {
    state: {
        tableDatas: [],
        answerTotal: 0,
        extandTotal: 0,
        standTotal: 0,
        querySetting: {
            page: 1
        },
        treeData: [],
        questionCreators: [],
        widgetsColor: ""
    },
    mutations: {
        treesDataChange(state, treeData) {
            let newDatas = {
                label: i18n.t("zhiji.common.allClassify"),
                id: "-1",
                smallLabel: "",
                children: treeData
            };
            state.treeData = newDatas;
        },
        updateQuestionList(state, tableData) {
            state.tableDatas.splice(0, state.tableDatas.length, ...tableData.dataset);
            state.standTotal = tableData.standTotal;
        },
        updateExtQuestionTotal(state, extQuesTotal) {
            state.extandTotal = extQuesTotal;
        },
        updateAnswersTotal(state, answerTotal) {
            state.answerTotal = answerTotal;
        },
        updateQuesListSetting(state, setting = {}) {
            state.querySetting = Object.assign({}, state.querySetting, setting);
        },
        updateQuesCreators(state, creators) {
            state.questionCreators.push(...creators);
        },
        clearCreatorOption(state) {
            state.questionCreators.splice(0);
        },
        updateWidgetsColor(state, colorData) {
            state.widgetsColor = colorData;
        },
        initQuerySetting(state) {
            state.querySetting = {};
        }
    },
    actions: {
        getTreesData(context) {
            getTreesData().then(function(dataList) {
                context.commit("treesDataChange", dataList);
            });
        },
        addQuestionTrees(context, data) {
            addQuestionTrees(data).then(function(result) {
                result === "success" ? context.dispatch("getTreesData") : "";
            });
        },
        updateQuestionTrees(context, data) {
            updateQuestionTrees(data).then(function(result) {
                result === "success" ? context.dispatch("getTreesData") : "";
            });
        },
        deleteQuestionTrees(context, data) {
            deleteQuestionTrees(data).then(function(result) {
                result === "success"
                    ? context.dispatch("getTreesData")
                    : context.dispatch("showModal", {
                          type: "MessageModal",
                          data: {
                              type: "error",
                              message: i18n.t("zhiji.knowlege.deleteErrorTip")
                          }
                      });
            });
        },
        moveQuestionTrees(context, data) {
            moveQuestionTrees(data).then(function(result) {
                context.dispatch("getTreesData");
            });
        },
        queryQuestionList(context, param) {
            param && context.commit("updateQuesListSetting", param);
            queryQuestionList(context.state.querySetting).then(function(tableData) {
                context.commit("updateQuestionList", tableData);
            });
        },
        queryExtQuestionTotal(context, param) {
            param && context.commit("updateQuesListSetting", param);
            queryExtQuestionTotal(context.state.querySetting).then(function(total) {
                context.commit("updateExtQuestionTotal", total);
            });
        },
        queryAnswersTotal(context, param) {
            param && context.commit("updateQuesListSetting", param);
            queryAnswersTotal(context.state.querySetting).then(function(total) {
                context.commit("updateAnswersTotal", total);
            });
        },
        initQuesCreators(context) {
            queryQuesCreators().then(function(creators) {
                context.commit("updateQuesCreators", creators);
            });
        },
        quesOnlineStatusChange(context, param) {
            questionStatusUpdate(param).then(function() {
                context.dispatch("queryQuestionList");
            });
        },
        deleteQuestions(context, param) {
            new Promise(function(resolve) {
                context.dispatch("checkQuestionStatus", param);
                resolve();
            })
                .then(function() {
                    return questionStatusUpdate(param).then(function() {
                        context.dispatch("queryQuestionList");
                    });
                })
                .catch(err => {
                    if (err.errorType == "ParamError" || err.errorType == "ServerRespError") {
                        context.dispatch("showModal", {
                            type: "MessageModal",
                            data: {
                                type: "error",
                                message: err.message
                            }
                        });
                    }
                });
        },
        setFirstQuestion(context, param) {
            setFirstQuestion(param).then(function() {
                context.dispatch("queryQuestionList");
            });
        },
        setRevealQuestion (context, param) {
            setRevealQuestion(param).then((result) => {
                context.dispatch('queryQuestionList');
            });
        },
        checkQuestionStatus(context, param) {
            context.state.tableDatas.some(value => {
                param.questionId.some(item => {
                    if (value.questionId === item) {
                        if (value.state === i18n.t("zhiji.knowlege.online")) {
                            throw new ParamError(i18n.t("zhiji.knowlege.deleteOnlineQuesTip"));
                        }
                    }
                });
            });
        },
        transferQuestions(context, param) {
            new Promise(function(resolve) {
                context.dispatch("checkTransferStatus", param);
                resolve();
            })
                .then(function() {
                    return transferQuesClass(param).then(function() {
                        context.dispatch("queryQuestionList");
                    });
                })
                .catch(err => {
                    if (err.errorType == "ParamError" || err.errorType == "ServerRespError") {
                        context.dispatch("showModal", {
                            type: "MessageModal",
                            data: {
                                type: "error",
                                message: err.message
                            }
                        });
                    }
                });
        },
        checkTransferStatus(context, param) {
            let questionList = [];
            isArray(param.questionId) ? (questionList = param.questionId) : questionList.push(param.questionId);
            context.state.tableDatas.some(value => {
                questionList.some(item => {
                    if (value.questionId === item) {
                        if (value.state === i18n.t("zhiji.knowlege.offline") || value.state === i18n.t("zhiji.knowlege.draft")) {
                            throw new ParamError(i18n.t("zhiji.knowlege.offlineQuesTransTip"));
                            return true;
                        }
                    }
                });
            });
        },
    }
};
